import {  
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getValidEndDate,
  removeDuplicates,
  orderBy,  
  getPreviousPayCycle,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import AdvancedFilter from './AdvancedFilter';
import { generateString, getMultilevelGroupedData, setDownloadingStatus } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

// Column header array
const headCells = [
  {
    id: 'email',
    numeric: false,
    disablePadding: true,
    label: 'Email'
  },
  {
    id: 'hire_Date',
    numeric: false,
    disablePadding: true,
    label: 'Hire Date',
    type: 'Text',
    format: 'Date'
  }
];
let temcurrentGroupedRow = [];
export default class NewHireEmployeeReport extends Component {
  // Constructor to define the state
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],
      employeeSummary: [],
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      showReport: false,
      marketMasterData: [],
      departmentMasterData: [],
      designationMasterData: [],
      employeeSupervisorList: [],
      employeeMasterData: [],
      market: [{ marketName: 'All' }],
      designation: [{ designation: 'All' }],
      department: [{ departmentName: 'All' }],
      supervisor: [{ supervisorName: 'All' }],
      employee: [{ employeeName: 'All' }],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Department',
              value: 'department',
              ssrsReport: 'Department',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              id: 'department',
              order: 2
            },
            {
              key: 'Title',
              value: 'title',
              id: 'title',
              ssrsReport: 'Title',
              numeric: false,
              disablePadding: false,
              label: 'Title',
              type: 'Text',
              order: 3
            },
            {
              key: 'Supervisor',
              value: 'supervisor',
              id: 'supervisor',
              ssrsReport: 'Supervisor',
              numeric: false,
              disablePadding: false,
              label: 'Supervisor',
              type: 'Text',
              order: 4
            },
            {
              key: 'Employee',
              value: 'employee',
              id: 'employee',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 5
            }
          ],
          selected: [{
            key: 'Market',
            value: 'market',
            id: 'market',
            ssrsReport: 'Market',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate,
        order: 'asc',
        orderBy: 'nam'
      }
    };

    this.baseState = this.state;
  }

  // Method is used to get data before components are mounted
  componentDidMount() {
    this.GetMasterData();
  }

  // Go to Report list page
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Date change event of calendar
  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');

    if (name === 'startDate') {
      advanceFilterConfig.startDate = moment(date).format(DateFormat);
      localStorage.setItem('selectedstartDate', moment(date).format(DateFormat));

      this.setState({
        [name]: moment(date).format(DateFormat)
      });
    } else {
      advanceFilterConfig.endDate = moment(date).format(DateFormat);
      localStorage.setItem('selectedendDate', moment(date).format(DateFormat));

      this.setState({
        [name]: moment(date).format(DateFormat)
      });
    }
  };

  // Get Master data to fill filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Employee.GetEmployeeSupervisorList,
        key: 'employeeSupervisorList'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      }
    ])
      .then(
        ({
          marketMasterData,
          departmentMasterData,
          designationMasterData,
          employeeSupervisorList,
          employeeMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            marketMasterData: marketMasterData.data,
            departmentMasterData: departmentMasterData.data,
            designationMasterData: designationMasterData.data,
            employeeSupervisorList: employeeSupervisorList.data,
            employeeMasterData: employeeMasterData.data
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.handleSubmit();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get report data based on selected filters
  GetNewHireEmployee = () => {
    const { market, department, designation, supervisor, employee } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const designationId = _.cloneDeep(designation.map((x) => x.designationID));
    const supervisorId = _.cloneDeep(supervisor.map((x) => x.supervisorId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));

    const payPeriodStartDate = this.state.startDate;
    const payPeriodEndDate = this.state.endDate;
    const params = {
      startDate: moment(payPeriodStartDate).format(DateFormat),
      endDate: moment(payPeriodEndDate).format(DateFormat),
      marketId: marketId.join('|'),
      departmentId: departmentId.join('|'),
      designationId: designationId.join('|'),
      supervisorId: supervisorId.join('|'),
      employeeId: employeeId.join('|')
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetNewHireEmployee,
        params,
        key: 'employeeData'
      }
    ])
      .then(({ employeeData }) => {
        this._asyncRequest = null;
        if (employeeData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          employeeData: employeeData.data,
          employeeSummary: employeeData.config,
          showReport: true,
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Handle sorting on table columns
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  // Render table
  renderTable = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        <TableBody>{this.renderTableRow(
          orderBy(employeeData, this.state.orderBy, this.state.order)
        )}
        </TableBody>
      </Table>
    );
  };

  // Close sliding panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Reset filters and reload report data
  resetPage = () => {
    localStorage.setItem('selectedstartDate', moment().startOf('month').format(DateFormat));
    localStorage.setItem('selectedendDate', moment().endOf('month').format(DateFormat));
    localStorage.setItem('DateRadioSelect', 'CDR');
    const { advanceFilterConfig } = this.state;    
    advanceFilterConfig.startDate = moment().startOf('month').format(DateFormat);
    advanceFilterConfig.endDate = moment().endOf('month').format(DateFormat);
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Department',
          value: 'department',
          ssrsReport: 'Department',
          numeric: false,
          disablePadding: false,
          label: 'Department',
          type: 'Text',
          id: 'department',
          order: 2
        },
        {
          key: 'Title',
          value: 'title',
          id: 'title',
          ssrsReport: 'Title',
          numeric: false,
          disablePadding: false,
          label: 'Title',
          type: 'Text',
          order: 3
        },
        {
          key: 'Supervisor',
          value: 'supervisor',
          id: 'supervisor',
          ssrsReport: 'Supervisor',
          numeric: false,
          disablePadding: false,
          label: 'Supervisor',
          type: 'Text',
          order: 4
        },
        {
          key: 'Employee',
          value: 'employee',
          id: 'employee',
          ssrsReport: 'Employee',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 5
        }
      ],
      selected: [{
        key: 'Market',
        value: 'market',
        id: 'market',
        ssrsReport: 'Market',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    });
    this.GetMasterData();
  };

  // Click event on Run Report button
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);    
    this.GetNewHireEmployee();
  };

  // Open sliding panel
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // Print report
  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Handle change event of filtered values
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Change event of Advanced filters
  onAddvanceFilterChange = (advanceFilterConfig) => {    
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    const endDate = getValidEndDate(advanceFilterConfig);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      startDate: (advanceFilterConfig.startDate),
      endDate: endDate
    }, () => { this.GetNewHireEmployee(); });
  };

  // Get column sequence based on grouping selected on Advanced filters
  getColumnSequence = () => {
    return removeDuplicates(
      [
        ...this.state.advanceFilterConfig.groupBy.selected,
        ...this.state.advanceFilterConfig.groupBy.masterData
      ],
      'key'
    );
  };

  // Adjust column sequence as per grouping selected
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach((x) => {
      currentGroupedRow.push({ key: x.value });
    });
    return currentGroupedRow;
  };

  // Render row wise data records
  renderTableRow = (data, onlydata = false) => {
    temcurrentGroupedRow = [];
    return this.renderTableCell(
      getMultilevelGroupedData(
        data,
        this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
      ),
      onlydata,
      []
    );
  };

  // Render table cells with formatted values
  renderTableCell = (groupedData, onlydata, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const sequence = this.getColumnSequence();

    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;
      let column5 = (temcurrentGroupedRow.find(x => x.key === sequence[4].value) || {})?.value || null;

      if (d.data !== undefined) {        
        this.renderTableCell(d.data, onlydata, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));      
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !== (keyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';

      const key = d.department + d.employeeId + '_' + rowCount + '_' + i;
      if (d.data === undefined) {
        if (onlydata) {
          const rowData = {};
          rowData[sequence[0].value] = getFormattedValues(column1 !== d[sequence[0].value] ? d[sequence[0].value] : '', 'Text', true);
          rowData[sequence[1].value] = getFormattedValues(column2 !== d[sequence[1].value] ? d[sequence[1].value] : '', 'Text', true);
          rowData[sequence[2].value] = getFormattedValues(column3 !== d[sequence[2].value] ? d[sequence[2].value] : '', 'Text', true);
          rowData[sequence[3].value] = getFormattedValues(column4 !== d[sequence[3].value] ? d[sequence[3].value] : '', 'Text', true);
          rowData[sequence[4].value] = getFormattedValues(column5 !== d[sequence[4].value] ? d[sequence[4].value] : '', 'Text', true);
          rowData.email = d.email;
          rowData.hire_Date = d.hire_Date;
        } else {
          tableCell.push(
            <TableRow key={key} className={topBorderClass}>
              <TableCell className={
                evenOddClass +
                topBorderClass
              }>
                {getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[2].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[3].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[4].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.email === null
                  ? '-'
                  : getFormattedValues(d.email, 'Text')}
              </TableCell>              
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.hire_Date === null
                  ? 'NA'
                  : getFormattedValues(d.hire_Date, 'Date')}
              </TableCell>
            </TableRow>
          );
        }
      }
      rowCount++;
      column1 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
      column5 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[4].value) || {}).value ?? null;
    });
    return tableCell;
  }

  // Download report into excel or pdf file based on filters selected
  downloadFile = (fileMimeType, type, isPrint = false) => {
    let { market, department, employee, endDate, startDate, advanceFilterConfig, designation, supervisor } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];
    market = market.filter(x => x.marketName !== 'All');
    department = department.filter(x => x.departmentName !== 'All');
    designation = designation.filter(x => x.designation !== 'All');
    supervisor = supervisor.filter(x => x.supervisorName !== 'All');
    employee = employee.filter(x => x.employeeName !== 'All');

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const designationId = _.cloneDeep(designation.map((x) => x.designationID));
    const supervisorId = _.cloneDeep(supervisor.map((x) => x.supervisorId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));

    if (market && market.length > 0) {      
      dataValue.push({ key: 'MarketId', value: marketId.join('|') === undefined ? '' : marketId.join('|') });
    }
    if (department && department.length > 0) {
      dataValue.push({ key: 'DepartmentId', value: departmentId.join('|') === undefined ? '' : departmentId.join('|') });
    }
    if (designation && designation.length > 0) {
      dataValue.push({ key: 'DesignationId', value: designationId.join('|') === undefined ? '' : designationId.join('|') });
    }
    if (supervisor && supervisor.length > 0) {      
      dataValue.push({ key: 'SupervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }
    if (employee && employee.length > 0) {
      dataValue.push({ key: 'EmployeeId', value: employeeId.join('|') === undefined ? '' : employeeId.join('|') });
    }
    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Employee%20New%20Hire%20Report', type);
    const uploadingKey = generateString(6);

    // setDownloadingStatus(
    //   uploadingKey,
    //   'Employee New Hire Report',
    //   'downloading',
    //   '',
    //   'Downloading file'
    // );
    downloadReport(
      url,
      'Employee New Hire Report',
      fileMimeType,
      type,
      isPrint
    );
    // setDownloadingStatus(
    //   uploadingKey,
    //   'Employee New Hire Report',
    //   'completed',
    //   '',
    //   'Processing of User Import file complete'
    // );
  }

  // Render method to render components based on selected filters
  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      marketMasterData,
      departmentMasterData,
      designationMasterData,
      employeeSupervisorList,
      showReport,
      advanceFilterConfig,
      openSlidingPanel,
      employeeMasterData
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (designationMasterData.find(x => x.designation === 'All') === undefined) {
      designationMasterData.unshift({ designation: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }
    if (employeeSupervisorList.find(x => x.supervisorName === 'All') === undefined) {
      employeeSupervisorList.unshift({ supervisorName: 'All' });
    }

    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'New_Hire_Employee_Report'}
                title={'Employee New Hire Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Employee New Hire Report
            </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print"
                style={{ marginLeft: '10px' }}
              >
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={removeDuplicates(marketMasterData, 'marketName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      // placeholder="Market"
                      />
                    )}
                  />

                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.designation}
                    onChange={(e, val) =>
                      this.handleChange(e, val, 'designation', 'designation')
                    }
                    options={removeDuplicates(designationMasterData, 'designation')}
                    limitTags={2}
                    getOptionLabel={(option) => option.designation}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Title"
                      // placeholder="Title"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.department}
                    onChange={(e, val) => this.handleChange(e, val, 'department', 'departmentName')}
                    options={removeDuplicates(departmentMasterData, 'departmentName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.departmentName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Department"
                      // placeholder="Department"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    id="tags-standard"
                    blurOnSelect
                    value={this.state.supervisor}
                    onChange={(e, val) => this.handleChange(e, val, 'supervisor', 'supervisorName')}
                    options={removeDuplicates(employeeSupervisorList, 'supervisorName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.supervisorName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor"
                      // placeholder="Supervisor"
                      />
                    )}
                  />
                  <></>
                </Grid>

                {/* <Grid item xs={12} lg={2} className="MuiFormControl-marginNormal"> */}
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.employee}
                    onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                    id="tags-standard"
                    options={removeDuplicates(employeeMasterData, 'employeeName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Employee"
                      // placeholder="Market"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={2} className="MuiFormControl-marginNormal">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Start Date"
                        format="MM/dd/yyyy"
                        // maxDate={endDate}
                        name="startDate"
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="End Date"
                        format="MM/dd/yyyy"
                        minDate={startDate}
                        // maxDate={moment().endOf('month').format('MM/DD/YYYY')}
                        name="endDate"
                        value={endDate}
                        onChange={(e) => this.handleDateChange(e, 'endDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>

                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={employeeData}
                />

              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && employeeData == null && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && (
                <>
                  {employeeData !== null && (
                    <div className="container" style={{ marginTop: '1rem' }}>
                      <TableContainer component={Paper}>
                        {this.renderTable(employeeData)}
                      </TableContainer>
                    </div>
                  )}
                </>
              )}
            </>
          )}
      </div>
    );
  }
}
